import { Link } from "react-router-dom";
import MansionGenChat from "../components/MansionGenChat";
import PublicText from "../components/PublicText";
import { PUBLIC_BRAND } from "../lib/public-copy";

export default function CommunityPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/" className="text-sm text-cyan-700 hover:underline">
          ← Back to CaribNavi
        </Link>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-cyan-600 mt-6 mb-2">
          Caribbean Community
        </p>
        <h1 className="text-3xl font-serif font-bold text-slate-900 mb-2">Island Chat</h1>
        <PublicText as="p" className="text-slate-600 text-sm mb-8 max-w-xl leading-relaxed">
          {PUBLIC_BRAND.unifiedNetworkLead}
        </PublicText>
        <MansionGenChat title="CaribNavi Chat" theme="light" className="max-w-2xl" />
      </div>
    </div>
  );
}
